import { render, staticRenderFns } from "./inresourcesDetail.vue?vue&type=template&id=2e174cbe&"
import script from "./inresourcesDetail.vue?vue&type=script&lang=js&"
export * from "./inresourcesDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports